
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[searchPageSlug]",
      function () {
        return require("private-next-pages/[searchPageSlug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[searchPageSlug]"])
      });
    }
  